import React from 'react';

/**
 * Password rules, mirrored from server/utils/passwordPolicy.js.
 *
 * The server is still the authority and re-checks every request — this exists
 * so the user can see what is required and watch each rule turn green as they
 * type, rather than guessing and being rejected.
 */
export const PASSWORD_RULES = [
  { id: 'length',    label: 'At least 10 characters',                    test: v => (v || '').length >= 10 },
  { id: 'uppercase', label: 'At least 1 uppercase letter (A-Z)',         test: v => /[A-Z]/.test(v || '') },
  { id: 'lowercase', label: 'At least 1 lowercase letter (a-z)',         test: v => /[a-z]/.test(v || '') },
  { id: 'number',    label: 'At least 1 number (0-9)',                   test: v => /[0-9]/.test(v || '') },
  { id: 'symbol',    label: 'At least 1 symbol (e.g. ! @ # $ % & *)',    test: v => /[^A-Za-z0-9\s]/.test(v || '') }
];

export function isPasswordValid(password) {
  return PASSWORD_RULES.every(r => r.test(password));
}

export function failedRules(password) {
  return PASSWORD_RULES.filter(r => !r.test(password)).map(r => r.label);
}

/**
 * Live checklist. Before the user types anything the rules are shown plainly
 * as guidance; once they start typing each one turns green or red.
 */
const PasswordRequirements = ({ password = '', className = '' }) => {
  const touched = (password || '').length > 0;

  return (
    <div className={`mt-2 ${className}`}>
      <p className="text-xs font-medium text-gray-600 mb-1">Password must contain:</p>
      <ul className="space-y-0.5">
        {PASSWORD_RULES.map(rule => {
          const ok = rule.test(password);
          return (
            <li
              key={rule.id}
              className={`text-xs flex items-start gap-1.5 ${
                !touched ? 'text-gray-500' : ok ? 'text-green-700' : 'text-red-600'
              }`}
            >
              <span aria-hidden="true" className="mt-px">
                {!touched ? '•' : ok ? '✓' : '✗'}
              </span>
              <span>{rule.label}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default PasswordRequirements;
